import { BsAirplane, BsTruck } from "react-icons/bs";
import { FaShip } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { tariffHeadline } from "../../data/deliveryTariffs";

export default function ChinaContent({
  item,
  user,
  currentCountryName,
  currentCountry,
}) {
  const { t } = useTranslation();

  // Scheduled two-zone pricing (China refresh 2026-08-17). When the office
  // carries price_scheduled + price_scheduled_highland, surface both prices
  // in the header. If scheduled_from is still in the future, prefix a small
  // "from DD.MM.YYYY" note so the customer knows when the change kicks in.
  // A home-delivery office is priced from its tariff alone, so that is what
  // the header shows; the scheduled overlay only applies without one.
  const headline = tariffHeadline(item);
  const hasScheduled =
    !item?.home_delivery_only &&
    item?.price_scheduled != null && item?.price_scheduled_highland != null;
  const scheduledFrom = item?.scheduled_from
    ? new Date(item.scheduled_from)
    : null;
  const scheduledInFuture = scheduledFrom
    ? scheduledFrom.setHours(0, 0, 0, 0) >
      new Date().setHours(0, 0, 0, 0)
    : false;
  const formatDay = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    return `${String(dt.getDate()).padStart(2, "0")}.${String(
      dt.getMonth() + 1
    ).padStart(2, "0")}.${dt.getFullYear()}`;
  };

  return (
    <>
      {item?.country !== null && item?.country !== "" && (
        <div className="p-4 border-b border-gray-200 flex gap-2 items-center ">
          {item?.type === 1 && <BsTruck className="text-2xl text-teal_600" />}
          {item?.type === 2 && (
            <BsAirplane className="text-2xl text-teal_600" />
          )}
          {item?.type === 3 && <FaShip className="text-2xl text-teal_600" />}
          <div className="flex gap-2 items-center sm:flex-col sm:items-start">
            <p className="text-gray-500 text-sm md:text-xs font-semibold">
              Warehouse:
            </p>
            {item.id === 5 ? (
              <p className="font-semibold text-sm md:text-xs">China-Air</p>
            ) : (
              <p className="font-semibold text-sm md:text-xs">
                {item?.country}
              </p>
            )}
          </div>
          {headline ? (
            <div className="ml-auto flex gap-2 items-baseline flex-wrap sm:ml-0">
              <span className="flex items-baseline gap-1">
                <span className="text-gray-500 text-[11px] md:text-[10px]">
                  {t("tbilisi_and_regions") || "თბილისი / რეგიონები"}:
                </span>
                <span className="font-bold text-teal_600 text-sm md:text-xs">
                  {headline.upTo.normal.toFixed(2)}$
                </span>
              </span>
              <span className="flex items-baseline gap-1">
                <span className="text-gray-500 text-[11px] md:text-[10px]">
                  {t("highland") || "მაღალმთიანი"}
                  {headline.above && headline.above.highland.max !== headline.upTo.highland
                    ? ` (${headline.includedTo} კგ-მდე)`
                    : ""}
                  :
                </span>
                <span className="font-bold text-teal_600 text-sm md:text-xs">
                  {headline.upTo.highland.toFixed(2)}$
                </span>
              </span>
            </div>
          ) : hasScheduled ? (
            <div className="ml-auto flex flex-col items-end gap-0.5 sm:items-start sm:ml-0">
              {scheduledInFuture && item?.price !== null && item?.price !== "" && (
                <div className="flex gap-2 items-baseline">
                  <span className="text-gray-500 text-[11px] md:text-[10px]">
                    {t("current_price") || "მიმდინარე"}:
                  </span>
                  <span className="font-semibold text-sm md:text-xs">
                    {item?.price}$
                  </span>
                </div>
              )}
              <div className="flex gap-2 items-baseline flex-wrap">
                {scheduledInFuture && (
                  <span className="text-teal_600 text-[10px] font-bold uppercase tracking-wider">
                    {formatDay(item.scheduled_from)} {t("from_date_label") || "დან"}
                  </span>
                )}
                <span className="flex items-baseline gap-1">
                  <span className="text-gray-500 text-[11px] md:text-[10px]">
                    {t("tbilisi_and_regions") || "თბილისი / რეგიონები"}:
                  </span>
                  <span className="font-bold text-teal_600 text-sm md:text-xs">
                    {Number(item.price_scheduled).toFixed(2)}$
                  </span>
                </span>
                <span className="flex items-baseline gap-1">
                  <span className="text-gray-500 text-[11px] md:text-[10px]">
                    {t("highland") || "მაღალმთიანი"}:
                  </span>
                  <span className="font-bold text-teal_600 text-sm md:text-xs">
                    {Number(item.price_scheduled_highland).toFixed(2)}$
                  </span>
                </span>
              </div>
            </div>
          ) : (
            item?.price !== null && item?.price !== "" && (
              <div className="flex gap-2 items-center sm:flex-col sm:items-start ml-auto">
                <p className="text-gray-500 text-sm md:text-xs font-semibold">
                  Price:
                </p>
                <p className="font-semibold text-sm md:text-xs">
                  {item?.price}$
                </p>
              </div>
            )
          )}
        </div>
      )}
      <div className="p-4 border-b border-gray-200 flex gap-2 items-center sm:flex-col sm:items-start">
        <p className="text-gray-500 text-sm md:text-xs font-semibold">
          Name / Surname :
        </p>
        <p className="font-semibold text-sm md:text-xs">
          {user?.fname_eng
            ? `${user?.fname_eng} ${user?.lname_eng}`
            : user?.cname}
        </p>
      </div>
      {currentCountryName !== null && currentCountryName !== "" && (
        <div className="p-4 border-b border-gray-200 flex gap-2 items-center sm:flex-col sm:items-start">
          <p className="text-gray-500 text-sm md:text-xs font-semibold">
            Country:
          </p>
          <p className="font-semibold text-sm md:text-xs">
            {currentCountryName === "თურქეთი" && "Turkey"}
            {currentCountryName === "ჩინეთი" && "China"}
          </p>
        </div>
      )}
      {item?.state !== null && item?.state !== "" && (
        <div className="p-4 border-b border-gray-200 flex gap-2 items-center sm:flex-col sm:items-start">
          <p className="text-gray-500 text-sm md:text-xs font-semibold">
            {currentCountry === 4 ? "Neighborhood:" : "State / Province:"}
          </p>
          <p className="font-semibold text-sm md:text-xs">{item?.state}</p>
        </div>
      )}
      {item?.town !== null && item?.town !== "" && (
        <div className="p-4 border-b border-gray-200 flex gap-2 items-center sm:flex-col sm:items-start">
          <p className="text-gray-500 text-sm md:text-xs font-semibold">
            {currentCountry === 4 ? "Town / District:" : "Town / City:"}
          </p>
          <p className="font-semibold text-sm md:text-xs">{item?.town}</p>
        </div>
      )}
      {item?.street !== null && item?.street !== "" && (
        <div className="p-4 border-b border-gray-200 flex gap-2 items-center sm:flex-col sm:items-start">
          <p className="text-gray-500 text-sm md:text-xs font-semibold">
            {currentCountry === 4 ? "City / Province:" : "Region / District:"}
          </p>
          <p className="font-semibold text-sm md:text-xs">{item?.street}</p>
        </div>
      )}
      {item?.adress1 !== null && item?.adress1 !== "" && (
        <div className="p-4 border-b border-gray-200 flex gap-2 items-center sm:flex-col sm:items-start">
          <p className="text-gray-500 text-sm md:text-xs font-semibold">
            Address 1:
          </p>
          <p className="font-semibold text-sm md:text-xs">
            MGL{user?.id} {item?.adress1} MGL{user?.id}
          </p>
        </div>
      )}
      {item?.adress2 !== null && item?.adress2 !== "" && (
        <div className="p-4 border-b border-gray-200 flex gap-2 items-center sm:flex-col sm:items-start">
          <p className="text-gray-500 text-sm md:text-xs font-semibold">
            Adress 1 English
          </p>
          <p className="font-semibold text-sm md:text-xs">
            MGL{user?.id} {item?.adress2} MGL{user?.id}
          </p>
        </div>
      )}
      <div className="p-4 border-b border-gray-200 flex gap-2 items-center sm:flex-col sm:items-start">
        <p className="text-gray-500 text-sm md:text-xs font-semibold">
          Address 2:
        </p>
        <p className="font-semibold text-sm md:text-xs">MGL{user?.id}</p>
      </div>
      {item?.phone !== null && item?.phone !== "" && (
        <div className="p-4 flex gap-2 border-b border-gray-200 items-center sm:flex-col sm:items-start">
          <p className="text-gray-500 text-sm md:text-xs font-semibold">
            Phone:
          </p>
          <p className="font-semibold text-sm md:text-xs">{item?.phone}</p>
        </div>
      )}
      {item?.zip_code !== null && item?.zip_code !== "" && (
        <div className="p-4  flex gap-2 items-center sm:flex-col sm:items-start">
          <p className="text-gray-500 text-sm md:text-xs font-semibold">
            Postal Code:
          </p>
          <p className="font-semibold text-sm md:text-xs">{item?.zip_code}</p>
        </div>
      )}
    </>
  );
}
